import moment from "moment";
import { Fare, FarePriceBreakdown } from "../Models";

export function financialNumber(x: number) {
  return parseFloat(Number(x).toFixed(2));
}
const dateFormat = "DD/MM/YYYY HH:mm";

export function formatDateEventualy(d?: string) {
  if (!d || d.length === 0) {
    return "inconnu";
  } else {
    return moment(d).format(dateFormat);
  }
}

const { REACT_APP_RISOLI_ENDPOINT, REACT_APP_RISOLI_PASSWORD } = process.env;

export const requestPrice = (fare: Fare): Promise<FarePriceBreakdown> => {
  var raw = JSON.stringify(fare);

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append(
    "Authorization",
    "Basic " + btoa("user:" + REACT_APP_RISOLI_PASSWORD)
  );

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  return new Promise<FarePriceBreakdown>((resolve, reject) => {
    fetch(
      REACT_APP_RISOLI_ENDPOINT + "/missionFare/calculate",
      requestOptions as RequestInit
    )
      .then(async (response) => {
        const json = JSON.parse(await response.text()) as FarePriceBreakdown;
        resolve(json);
      })
      .catch((error) => {
        console.error("Mission price error", error);
        reject(error);
      });
  });
};
